var WebFont = require('webfontloader');

export default {
  init: function () {
    WebFont.load({
      typekit: {
        id: 'swm8yer',
      },
      // google: {
      //   families: ['Poppins:400,500,600,700,800'],
      // },
      // custom: {
      //   families: ['BebasNeau'],
      // },
    });
  },
};
